var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"marqueeBox",staticClass:"marqueebox",on:{"mouseenter":_vm.stop,"mouseleave":_vm.roll}},[_c('span',{ref:"marqueeText",style:({transform: 'translateX('+ _vm.left +'px)'})},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }